import { render, staticRenderFns } from "./ReceivePay.vue?vue&type=template&id=689e2255&scoped=true"
import script from "./ReceivePay.vue?vue&type=script&lang=js"
export * from "./ReceivePay.vue?vue&type=script&lang=js"
import style0 from "./ReceivePay.vue?vue&type=style&index=0&id=689e2255&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e2255",
  null
  
)

export default component.exports